import React, { useState } from "react";
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { toast } from "react-toastify";
import Login from "../../../services/loginApi";
import ModalSendACodeToLogin from "./modalSendACodeToLogin";

const ModalRequestNewPassword = ({ isOpen, setIsOpen }: any) => {
  const finalRef = React.useRef(null);

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSendCodeModal, setShowSendCodeModal] = useState(false);

  const sentEmailRequestPassword = async () => {
    try {
      setLoading(true);
      await Login.PostSms(email, "resetsenha", "S");
      toast.success(
        "Solicitação enviada com sucesso! Verifique seu SMS, ou E-mail."
      );
      setShowSendCodeModal(true);
      setLoading(false);
      onClose();
    } catch (err) {
      setLoading(false);

      const error = err as { response?: { data?: string } };

      const errorMessage =
        error?.response?.data ||
        "Erro ao solicitar nova senha, tente novamente!";
      toast.error(errorMessage);
    }
  };

  const handleChange = (value: string) => {
    setEmail(value);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const functionPai = (code: string) => {
    console.log("Código de verificação:", code);
  };

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"} my={2}>
              <Text fontSize={"xl"} fontWeight={"bold"}>
                Esqueceu sua senha?
              </Text>
            </Flex>
          </ModalHeader>
          <ModalBody>
            <Flex flexDir={"column"}>
              <FormControl my={2}>
                <FormLabel>
                  Você receberá um código por SMS ou E-mail, caso seja Código
                  Fixo ou Google Auth, é só digitar o codigo!
                </FormLabel>
              </FormControl>
              <FormControl my={2}>
                <FormLabel>Digite seu e-mail</FormLabel>
                <Input
                  value={email}
                  placeholder="Seu e-mail"
                  onChange={(e) => handleChange(e.target.value)}
                />
              </FormControl>
            </Flex>
          </ModalBody>

          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={"gray"} mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              background={"blue"}
              color={"white"}
              isLoading={loading}
              isDisabled={email === "" || loading}
              onClick={() => sentEmailRequestPassword()}
            >
              Solicitar nova senha
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {showSendCodeModal && (
        <ModalSendACodeToLogin
          isOpen={showSendCodeModal}
          setIsOpen={setShowSendCodeModal}
          functionPai={functionPai}
          email={email}
          type="S"
        />
      )}
    </>
  );
};

export default ModalRequestNewPassword;
